import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Stack, Typography } from "@mui/material";

import { ReactComponent as AltiusLogo } from "../../../assets/icons/onboarding-logo.svg";

interface WelcomeStepProps {
  onNext: () => void;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "#ffffff"
      }}
    >
      <Box
        sx={{
          maxWidth: "500px",
          textAlign: "center",
          px: 3
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ mb: 4 }}>
          <AltiusLogo width="100%" height="36px" />
        </Stack>

        <Typography
          variant="h3"
          sx={{
            fontSize: "36px",
            fontWeight: 600,
            color: "#0a3142",
            mb: 2
          }}
        >
          Welcome to Altius
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: "17px",
            lineHeight: 1.5,
            color: "#071f36",
            mb: "20px"
          }}
        >
          Let&apos;s set up your workspace. This takes about two minutes and helps us tailor the platform to how you
          work.
        </Typography>

        <Button
          variant="contained"
          onClick={onNext}
          endIcon={<ArrowForwardIcon />}
          sx={{
            bgcolor: "#071f35",
            color: "#fff",
            boxShadow: "none",
            fontSize: "15px",
            fontWeight: 500,
            textTransform: "none",
            "&:hover": {
              bgcolor: "#0f2d47"
            }
          }}
        >
          Get started
        </Button>
      </Box>
    </Box>
  );
};
